import {AxiosCategory, getAxios, getAxiosTotall} from "./ApiInstance"

////////////////// Get Api ///////////////////
export const AddressList=(callback) => {
    getAxios().get("address/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getCurrent=(callback) => {
    getAxios().get("address/detail/").then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
};
export const getUserInfo=(callback) => {
    getAxios().get("info/").then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
};

export const getRestaurantsList=(callback) => {
    AxiosCategory().get("food/supplier/").then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
};
export const getSupermarketsList=(callback) => {
    AxiosCategory().get("supermarket/supplier/").then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
}
export const getSupermarketsOfferList=(id,callback) => {
    getAxiosTotall().get(`/supplier/${id}/offer/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getSupermarketsOfferListLimit=(id,callback) => {
    getAxiosTotall().get(`/supplier/${id}/offer/?limit`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getSupportListApi=(callback) => {
    getAxiosTotall().get(`/support/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const postSupportMessage=(data,callback) => {
    getAxiosTotall().post(`/support/`,data).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const postFeedBackApi=(data,callback) => {
    getAxiosTotall().post(`/support/feedback/`,data).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getMessageListApi=(id,callback) => {
    getAxiosTotall().get(`support/${id}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getCurrentOrderList=(callback) => {
    getAxios().get("order/all/?filter=current").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const GetShoppingCart=(callback) => {
    getAxiosTotall().get("cart/").then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
};
export const GetShoppingCartFinal=(callback) => {
    getAxiosTotall().get("cart/payment/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getSupplierInfo=(id,callback) => {
    getAxiosTotall().get(`/supplier/${id}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getSupplierComments=(id,callback) => {
    getAxiosTotall().get(`/supplier/${id}/comment/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const getSupplierAbout=(id,callback) => {
    getAxiosTotall().get(`/supplier/${id}/about/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};
export const categoryApiDependSupplier=(category,id,callback) => {
    AxiosCategory().get(`/${category}/${id}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getwaitingOrdersApi=(callback) => {
    getAxiosTotall().get(`user/order/awaitingpayment/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getSubsetsUserApi=(callback) => {
    getAxiosTotall().get('user/referral/links-list/').then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
///////////////// Post Api ///////////////////
export const LoginPhoneNumber=(info, callback)=>{
    getAxios().post("login/", info).then(response =>{
            
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const LogoutUser=(info, callback)=>{
    getAxios().post("logout/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const ConfirmLoginPhoneNumber=(info, callback)=>{
    getAxios().post("login/verification/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const AddAddres=(info, callback)=>{
    getAxios().post("address/add/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        }) 
};
export const AddUser=(info, callback)=>{
    getAxios().post("info/update/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const selectAddress=(info, callback)=>{
    getAxios().post("address/select/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const AddressDetailPostApi=(info, callback)=>{
    getAxios().post("address/detail/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};
export const RemoveAddress=(info, callback)=>{
    getAxios().post("address/remove/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => { 
            callback(false,error.data);
        })
    };
export const UpdateLocation=(info, callback)=>{
    getAxios().post("address/update/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const RemoveProductComment=(info, callback)=>{
    getAxios().post("comment/remove/product/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const RemoveSupplierComment=(info, callback)=>{
    getAxios().post("comment/remove/supplier/", info).then(response =>{
            callback(true,response.data);
        }).catch(error => {
            callback(false,error.data);
        })
};
export const addsupplierTofavorite=(info, callback)=>{
    getAxios().post("favorite/add/supplier/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};
export const removeSupplierTofavorite=(info, callback)=>{
    getAxios().post("favorite/remove/supplier/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
};
export const CooperationRequestApi=(info, callback)=>{
    getAxiosTotall().post("/join_us/add/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const UpdateProductCountInBasket=(info, callback)=>{
    getAxiosTotall().post("/cart/update/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const checkDiscount=(info, callback)=>{
    getAxiosTotall().post("/cart/checkdiscount/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const sendToIdPayPostApi=(info, callback)=>{
    getAxiosTotall().post("cart/pay/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const sendWatingToIdPayPostApi=(info, callback)=>{
    getAxios().post("order/awaitingpayment/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const pamentInfoPostApi=(info, callback)=>{
    getAxiosTotall().post("cart/checkpay/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};
export const IbanUserPostApi=(info, callback)=>{
    getAxios().post("info/updateiban/", info).then(response =>{
            callback(response.data);
        }).catch(error => {
            callback(error.data);
        })
};